import UploadBtn from "./UploadBtn.presenter";

export default UploadBtn;
